<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh">百年历史</router-link>
    </div>

    <div class="container-width hundred mb50 mt50">
      <div class="title">{{ hundredYearsData.title }}</div>
      <div class="flv">
        <hls-video
          :videoUrl="hundredYearsData.video"
          class="videoBox"
          :videoType="videoType"
          style="height: 370px; width: 100%"
          v-if="renderComponent && videoType == 'mp4'"
          :poster="hundredYearsData.img"
        ></hls-video>
        <hls-video
          :videoUrl="hundredYearsData.video"
          class="videoBox"
          :videoType="videoType"
          style="height: 370px; width: 100%"
          v-if="renderComponent && videoType == 'flv'"
          :poster="hundredYearsData.img"
        ></hls-video>
      </div>
      <p style="text-indent: 2rem" v-html="hundredYearsData.introduction"></p>
      <a class="w-more center mt50" href="/sjwh/article/hundred">查看更多</a>
    </div>
    <div class="container-width mb50" style="border-top: 1px solid #ddd">
      <div class="title mt50">《{{ thirtyYearsData.title }}》</div>
      <div class="thirty">
        <div class="thirty-img">
          <img :src="thirtyYearsData.img" />
        </div>

        <div class="thirty-nr" v-html="thirtyYearsData.introduction"></div>
      </div>
      <a class="w-more center mt50" :href="thirtyYearsData.fujianids"
        >点击下载</a
      >
    </div>
    <div class="container-width mt50" style="border-top: 1px solid #ddd">
      <div class="title mt50">图片盛京</div>
    </div>
    <section class="media-block">
      <!--  -->
      <div class="container-width" @click="goArticle">
        <vue-seamless-scroll
          :data="imgListData"
          :class-option="classOption"
          style="overflow: hidden; margin-bottom: 50px"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in imgListData"
              :key="index"
              :data-index="index"
            >
              <div class="img">
                <img :src="item.img" />
              </div>
              <p>{{ item.title }}</p>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </section>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import BANNER from "../../components/banner/sjwh";
import config from "../../config/dev";
// import flvjs from "flv.js";
import HlsVideo from "@/components/HlsVideo";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "SJWH",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        {
          name: "盛京医讯",
          path: "/sjwh/zhoukan",
          width: "33%",
        },
        {
          name: "盛京TV",
          path: "/sjwh/tv",
        },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh",
      imgListData: [],
      hundredYearsData: {
        img: "",
      },
      thirtyYearsData: {
        img: "",
      },
      showData: false,
      classOption: {
        //滚动的配置项
        step: 0.8,
        direction: 2,
      },
      renderComponent: false,
      videoType: "flv",
    };
  },
  components: { BANNER, vueSeamlessScroll, HlsVideo },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      // 图片盛京
      let parmes = {
        isShow: "1",
      };
      service.getHisList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });

          this.imgListData = res.content;
          this.showData = true;
          this.swiperImg();
        }
      });
      // 大道精深 大道精诚
      service.getMainRoad({}, (res) => {
        res.img = res.img
          ? config.url + "/file/downloadFile/" + res.img + "?isDownload=true"
          : "";
        if (res.url) {
          // this.videoInit(res.url);
        } else if (res.video) {
          res.video = res.video
            ? config.url + "/file/getVideo?id=" + res.video
            : "";
        }
        this.videoType = res.videotype;
        this.renderComponent = true;
        this.hundredYearsData = { ...res };
      });
      //奉天三十年
      service.getThirtyYears({}, (res) => {
        if (res.img) {
          res.img =
            config.url + "/file/downloadFile/" + res.img + "?isDownload=true";
        }
        if (res.fujianids) {
          res.fujianids =
            config.url +
            "/file/downloadFile/" +
            res.fujianids +
            "?isDownload=true";
        }

        this.thirtyYearsData = { ...res };
      });
    },
    swiperImg() {
      $(function () {
        // 医院公告
        $(".video-li").click(function () {
          $(this).addClass("on");
          $(this).siblings().removeClass("on");
          var index = $(this).index();
          $(".tv-list").hide().eq(index).show();
          $(".tv_more").hide().eq(index).show();
        });
        var swiper = new Swiper(".swiper-container", {
          slidesPerView: 4,
          spaceBetween: 30,
          mode: "horizontal",
          speed: 2000,
          autoplay: {
            delay: 2500,
            disableOnInteraction: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    },
    // 图集
    goArticle(e) {
      const item = e.target.closest(".swiper-slide"); // 定位元素

      if (item) {
        // 是否是滚动组件的某一行/列
        const { index } = item.dataset;
        console.log("this.imgListData[index].id", this.imgListData[index]);

        // 后续操作
        let id = this.imgListData[index].id;

        this.$router.push({
          path: `/sjwh/article`,
          query: {
            atlas: id,
          },
        });
      }
    },
    // 视频初始化
    videoInit(url) {
      if (flvjs.isSupported()) {
        var videoElement = document.getElementById("videoElement");

        this.flvPlayer = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true,
            hasAudio: true, // 是否有音频
            hasVideo: true, // 是否有视频
            url: url,
            enableStashBuffer: true, //是否启用缓存区
          },
          {
            enableWorker: false, //不启用分离线程
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            autoCleanupSourceBuffer: true, //自动清除缓存
            lazyLoad: false,
          }
        );
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
      }
    },
    handlehundred() {
      this.$router.push({
        path: `/sjwh/article/hundred`,
      });
    },
  },
  mounted() {},
  watch: {},
  destroyed() {
    // if (this.flvPlayer) {
    //   this.flvPlayer.pause();
    //   this.flvPlayer.unload();
    //   this.flvPlayer.detachMediaElement();
    //   this.flvPlayer.destroy();
    //   this.flvPlayer = null;
    // }
  },
};
</script>

<style scoped lang="scss">
// 公用
.title {
  margin-top: 30px;
  font-size: 1.6rem;
  font-weight: bold;
  text-align: center;
}
// 共用 end
.thirty {
  font-size: 1.2rem;
  line-height: 40px;
  margin-top: 50px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  .thirty-img {
    margin-right: 30px;
    width: 300px;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    height: 350px;
    border: 1px solid #eee;
    img {
      box-shadow: 6px 6px rgba(85, 85, 85, 0.2);
    }
  }
  .thirty-nr {
    width: calc(100% - 330px);
    text-indent: 3rem;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }
}
.hundred {
  .flv {
    width: 100%;
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    margin: 0px auto 0;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    width: 60vw;
    //width: 664px; /* 415*1.6 */
    // height: 499.2px; /* 312*1.6 */
    margin-top: 30px;
    video {
      // height: 499.2px; /* 312*1.6 */
      width: 100%;
      height: auto;
    }
  }
  p {
    margin-top: 15px;
    font-size: 1.2rem;
    line-height: 40px;
  }
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  position: relative;
  width: 310px;
  margin-right: 30px;
  p {
    position: absolute;
    bottom: 0px;
    background: rgba(6, 6, 6, 0.5);
    height: 50px;
    color: #fff;
    font-size: 1rem;
    padding: 10px 20px;
    box-sizing: border-box;
    width: 100%;
  }
}
@media only screen and (max-width: 720px) {
  // 公用
  .title {
    font-size: 1.4rem;
    margin-top: 20px;
  }
  // 共用 end
  .hundred {
    .flv {
      width: 90vw;
      margin-top: 20px;
    }
    p {
      margin-top: 15px;
      font-size: 12px;
      line-height: 24px;
    }
  }
  .thirty {
    -ms-flex-pack: justify;
    justify-content: space-between;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    margin-top: 20px;
    .thirty-img {
      width: 100%;
      margin-right: 0;
    }
    .thirty-nr {
      width: 100%;
      line-height: 24px;
      margin-top: 20px;
      font-size: 12px;
    }
  }

  .media-block {
    height: 200px;
  }
  .swiper-slide {
    width: 210px;
    height: 200px;
    margin-right: 30px;
  }
}
</style>
